import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/cad-edit/$id")({
  beforeLoad: ({ params }) => {
    // 旧链接重定向到独立预览页（不要进文档中心列表——那里要求带目录）
    throw redirect({ to: "/file-preview/$fileId", params: { fileId: params.id } });
  },
});
